"use client"
import { useState, useEffect } from 'react';
import CallComponent from "@/components/call/callComponent";
import { useSearchParams } from 'next/navigation'

export function MyModal() {
  
    let [open, setOpen] = useState(false);
    let [showSecond, setShowSecond] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const searchParams = useSearchParams()
    const userEmail = searchParams.get('email')
    const userName = searchParams.get('name')
    const source = searchParams.get('utm_source')

    let isSubmit = false;
    
    const [firstname, setName] = useState('');
    const [emailaddress, setEmail] = useState('');

    async function addToCart(formData) {
      setName(formData.get('firstname'))
      setEmail(formData.get('emailaddress'))
      //const emailaddress = formData.get('emailaddress')
      //console.log(emailaddress);
      setOpen(false);
      setShowSecond(true);
      //alert(`You searched for '${emailaddress}'`);
      
      //await updateCart(productId)
    }

    async function test() {
    }

    const Results = () => (
      <div id="results" className="search-results">
        <CallComponent lang="en" firstname={firstname} emailaddress={emailaddress} />
      </div>
    )
  

    return (
      <div>
      { showSecond ? <Results /> : <button className="bg-primary flex justify-center rounded-lg space-y-6 max-w-md px-5 py-3 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-white/20" onClick={handleClickOpen}>Start Here</button>  }
      <el-dialog>
        
  <dialog open={open}
        onClose={handleClose} id="dialog" aria-labelledby="dialog-title" className="fixed inset-0 size-auto max-h-none max-w-none overflow-y-auto bg-transparent backdrop:bg-transparent">
    <el-dialog-backdrop className="fixed inset-0 bg-gray-900/50 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"></el-dialog-backdrop>

    <div tabIndex="0" className="flex min-h-full items-end justify-center p-4 text-center focus:outline-none sm:items-center sm:p-0">
      <el-dialog-panel className="relative transform overflow-hidden rounded-lg bg-gray-800 text-left shadow-xl outline -outline-offset-1 outline-white/10 transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95">
        <form action={addToCart}>
        <div className="bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div className="">
            
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 id="dialog-title" className="text-base font-semibold text-white">Talk to Luna</h3>

              <div className="mt-2 relative z-0 w-full mb-5 group">
                <input type="text" name="firstname" id="firstname" className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
                <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Your Name</label>
              </div>

              <div className="mt-2 relative z-0 w-full mb-5 group">
                <input type="email" name="emailaddress" id="emailaddress" className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
                <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Your Email address</label>
              </div>

              
              
            
            </div>
          </div>
        </div>
        <div className="bg-gray-700/25 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button type="submit" className="inline-flex w-full justify-center rounded-md dark:bg-blue-600 dark:hover:bg-blue-700 px-3 py-2 text-sm font-semibold text-white sm:ml-3 sm:w-auto">Submit</button>
          <button type="button" command="close" commandfor="dialog" className="mt-3 inline-flex w-full justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-white/20 sm:mt-0 sm:w-auto">Cancel</button>
        </div>
        </form>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>
      </div>
    );
}
